import * as React from 'react';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import { ListIOCs } from "../ConstantIOCs";
import { ActionButton } from '../../../ayudas/Themes';
const array = ListIOCs;
function not(a, b) {
  return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

function union(a, b) {
  return [...a, ...not(b, a)];
}

export default function TransferListIOC(props) {
  const {valueDataTranfers,valueLeftTranfers} = props;
  const [checked, setChecked] = React.useState([]);
  const [left, setLeft] = React.useState(valueLeftTranfers);
  const [right, setRight] = React.useState(valueDataTranfers);

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const numberOfChecked = (items) => intersection(checked, items).length;

  const handleToggleAll = (items) => () => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
    props.DataTranfers(right.concat(leftChecked));
    props.valueHandleLeftDataTranfers(not(left, leftChecked));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
    if (left.concat(rightChecked).length === 26) {
      props.DataTranfers([]);
    }else{
      props.DataTranfers(not(right, rightChecked));
      props.valueHandleLeftDataTranfers(left.concat(rightChecked));
    }
  
  };

  const customList = (title, items) => (
    <Card style={{width:"100%"}}>
      <CardHeader
        sx={{ px: 2, py: 1, bgcolor: '#c59d48', color: '#fff' }}
        avatar={
          <Checkbox
            onClick={handleToggleAll(items)}
            checked={numberOfChecked(items) === items.length && items.length !== 0}
            indeterminate={
              numberOfChecked(items) !== items.length && numberOfChecked(items) !== 0
            }
            disabled={items.length === 0}
            inputProps={{
              'aria-label': 'all items selected',
            }}
          />
        }
        title={title}
        subheader={`${numberOfChecked(items)}/${items.length} selected`}
      />
      <Divider />
      <List
        sx={{
          height: 230,
          bgcolor: '#242933ac',
          overflow: 'auto',
        }}
        dense
        component="div"
        role="list"
      >
        {items.map((value) => {
          const labelId = `transfer-list-all-item-${value}-label`;

          return (
            <ListItem
              key={value}
              role="listitem"
              button
              onClick={handleToggle(value)}
            >
              <ListItemIcon>
                <Checkbox
                  checked={checked.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{
                    'aria-labelledby': labelId,
                  }}
                />
              </ListItemIcon>
              <ListItemText style={{ color: '#fff' }} id={labelId} primary={` Command ${value} : ${array[value-1]?.name}`} />
            </ListItem>
          );
        })}
        <ListItem />
      </List>
    </Card>
  );

  return (
    <Grid container spacing={1} justifyContent="center" alignItems="center">
      <Grid item md={1}/>
      <Grid item md={4}>{customList('Choices', left)}</Grid>
      <Grid item md={2}>
        <Grid container direction="column" alignItems="center">
          <ActionButton
            sx={{ my: 0.5 }}
            size="large"
            onClick={handleCheckedRight}
            disabled={leftChecked.length === 0}
            aria-label="move selected right"
            style={{fontSize:"25px", fontWeight:"bolder"}}
          >
            &gt;
          </ActionButton>
          <ActionButton
style={{fontSize:"25px", fontWeight:"bolder"}}
            sx={{ my: 0.5 }}
            size="large"
            onClick={handleCheckedLeft}
            disabled={rightChecked.length === 0}
            aria-label="move selected left"
          >
            &lt;
          </ActionButton>
        </Grid>
      </Grid>
      <Grid item md={4}>{customList('Chosen', right)}</Grid>
      <Grid item md={1}/>
    </Grid>
  );
}
